import { WretchError } from 'wretch/resolver'
import { ZodError } from 'zod'

import {
  ApiRequestErrorNetwork,
  ApiRequestErrorNetworkBackend,
  ApiRequestErrorUnknown,
  ApiRequestErrorValidation,
} from './ApiRequestError'
import { dynamicErrorSchema } from './dynamicErrorSchema'

const parseApiRequestNetworkError = (error: WretchError) => {
  const result = dynamicErrorSchema.safeParse(error.json)
  if (result.success)
    throw new ApiRequestErrorNetworkBackend(error, result.data)
  throw new ApiRequestErrorNetwork(error)
}

export const parseApiRequestError = (error: unknown) => {
  if (error instanceof ZodError) throw new ApiRequestErrorValidation(error)
  if (error instanceof WretchError) parseApiRequestNetworkError(error)
  throw new ApiRequestErrorUnknown(error)
}
